(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8115],{

/***/ 678:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);






const Accordion = (param)=>{
    let { title , content , index , activeIndex , setActiveIndex  } = param;
    const isActive = index === activeIndex;
    const handleClick = ()=>{
        setActiveIndex(isActive ? null : index);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.accordion_item,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.accordion_title,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ _jsx("h5", {
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: isActive ? /*#__PURE__*/ _jsx(FiMinus, {}) : /*#__PURE__*/ _jsx(FiPlus, {})
                    })
                ]
            }),
            isActive && /*#__PURE__*/ _jsx("p", {
                className: styles.accordion_content,
                children: content
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Accordion)));


/***/ }),

/***/ 967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5828);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2__);



// import sendDiningForm from "../../../lib/sendDiningForm";
// import useDiningForm from "../../../hooks/useDiningForm";


function DiningPageForm() {
    const [selectDate, setSelectDate] = useState(new Date());
    const [selectedOption, setSelectedOption] = useState("");
    const [form, setForm] = useState("");
    const [diningFormData, setDiningFormData] = useState({
        fullname: "",
        email: "",
        phoneno: "",
        message: ""
    });
    const handleDataChange = (e)=>{
        const { name , value  } = e.target;
        setDiningFormData((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const handleOptionChange = (event)=>{
        setSelectedOption(event.target.value);
    };
    const datenmonth = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric"
    });
    const handleDateChange = (date)=>{
        setSelectDate(date);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setForm({
            state: "loading"
        });
        try {
            const dataToSend = {
                ...diningFormData,
                date: selectDate,
                selectedOption: selectedOption
            };
            const res = await fetch("/api/senddiningform", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(dataToSend)
            });
            const { error  } = await res.json();
            if (error) {
                setForm({
                    state: "error",
                    message: error
                });
                return;
            }
            setForm({
                state: "success",
                message: "Your message was sent successfully."
            });
            setDiningFormData({
                fullname: "",
                email: "",
                phoneno: "",
                message: ""
            });
            selectedOption("");
        } catch (error1) {
            setForm({
                state: "error",
                message: "Something went wrong"
            });
        }
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("section", {
            className: "".concat(styles.form, " common_padding "),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row justify-content-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "text-center",
                            children: "Book Your Table"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-7 col-sm-12 contact_form",
                        children: /*#__PURE__*/ _jsxs("form", {
                            className: "row",
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "".concat(styles.form_group, " col-md-6 col-sm-12"),
                                    children: /*#__PURE__*/ _jsx("input", {
                                        id: "fullname",
                                        type: "text",
                                        name: "fullname",
                                        onChange: handleDataChange,
                                        value: diningFormData.fullname,
                                        className: "form-control",
                                        placeholder: "Full Name",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "".concat(styles.form_group, " col-md-6 col-sm-12"),
                                    children: /*#__PURE__*/ _jsx("input", {
                                        id: "email",
                                        name: "email",
                                        type: "email",
                                        onChange: handleDataChange,
                                        value: diningFormData.email,
                                        className: "form-control",
                                        placeholder: "Your Email",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "".concat(styles.form_group, " col-md-6"),
                                    children: /*#__PURE__*/ _jsx("input", {
                                        id: "phoneno",
                                        required: true,
                                        name: "phoneno",
                                        type: "number",
                                        onChange: handleDataChange,
                                        value: diningFormData.phoneno,
                                        className: "form-control",
                                        placeholder: "Phone Number"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "".concat(styles.form_group, " col-md-6"),
                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                        wrapperClassName: "diningform-date-picker",
                                        minDate: new Date(),
                                        className: styles.form_control,
                                        selected: selectDate,
                                        onChange: handleDateChange,
                                        placeholderText: "Please select a date"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "".concat(styles.form_group, " col-md-12"),
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "dining-radio-input",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "m-0",
                                                children: /*#__PURE__*/ _jsx("strong", {
                                                    children: "Booking For:"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("label", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "radio",
                                                        value: "Restaurant",
                                                        checked: selectedOption === "Restaurant",
                                                        onChange: handleOptionChange
                                                    }),
                                                    "Restaurant"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("label", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "radio",
                                                        value: "Bar",
                                                        checked: selectedOption === "Bar",
                                                        onChange: handleOptionChange
                                                    }),
                                                    "Bar"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "".concat(styles.form_group, " col-md-12"),
                                    children: /*#__PURE__*/ _jsx("textarea", {
                                        id: "message",
                                        name: "message",
                                        onChange: handleDataChange,
                                        value: diningFormData.message,
                                        className: "form-control",
                                        placeholder: "Message",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "submit",
                                    className: "common_btn",
                                    children: "SEND REQUEST"
                                }),
                                form.state === "loading" ? /*#__PURE__*/ _jsx("div", {
                                    children: "Sending...."
                                }) : form.state === "error" ? /*#__PURE__*/ _jsx("div", {
                                    className: "form_message error",
                                    children: form.message
                                }) : form.state === "success" && /*#__PURE__*/ _jsx("div", {
                                    className: "form_message success",
                                    children: "Thankyou! Your Message has been delivered."
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 1556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const Gallerymodal = (param)=>{
    let { galleryImages , currentIndex , setClickedImage  } = param;
    const [currentImageIndex, setCurrentImageIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(currentIndex);
    const [clickedImage, setClickedImageLocal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(galleryImages[currentIndex].bgImage || galleryImages[currentIndex].video);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setClickedImageLocal(galleryImages[currentImageIndex].bgImage || galleryImages[currentImageIndex].video);
    }, [
        currentImageIndex,
        galleryImages
    ]);
    const handleRotationRight = ()=>{
        const totalLength = galleryImages.length;
        if (currentImageIndex + 1 >= totalLength) {
            setCurrentImageIndex(0);
            return;
        }
        setCurrentImageIndex(currentImageIndex + 1);
    };
    const handleRotationLeft = ()=>{
        const totalLength = galleryImages.length;
        if (currentImageIndex === 0) {
            setCurrentImageIndex(totalLength - 1);
            return;
        }
        setCurrentImageIndex(currentImageIndex - 1);
    };
    const handleClick = (e)=>{
        if (e.target.classList.contains("dismiss")) {
            setClickedImage(null);
        }
    };
    const currentItem = galleryImages[currentImageIndex];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "modal_overlay dismiss",
            onClick: handleClick,
            children: [
                currentItem.bgImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: "modal_image",
                    src: clickedImage,
                    alt: "bigger picture"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("video", {
                    className: "modal_video",
                    controls: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                            src: clickedImage,
                            type: "video/mp4"
                        }),
                        "Your browser does not support the video tag."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "dismiss close_icon",
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/close-white.svg",
                        className: "dismiss",
                        width: 20,
                        height: 20,
                        alt: "Close arrow icon"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: handleRotationLeft,
                    className: "overlay-arrows_left",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/left-white.svg",
                        width: 30,
                        height: 30,
                        alt: "Left Icon"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: handleRotationRight,
                    className: "overlay-arrows_right",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/right-white.svg",
                        width: 30,
                        height: 30,
                        alt: "Right Icon"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Gallerymodal);


/***/ }),

/***/ 8368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Restaurantgallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1027);
/* harmony import */ var _styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6066);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _Gallerymodal_Gallerymodal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1556);





function Restaurantgallery() {
    const [clickedImage, setClickedImage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [currentIndex, setCurrentIndex] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const gallery_slider = {
        centerMode: true,
        dots: true,
        infinite: true,
        // centerPadding: "60px",
        arrows: true,
        speed: 500,
        slidesToShow: 2.3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.4,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const galleryImages = [
        {
            bgImage: "/images/Gallery/img-1.jpg"
        },
        {
            bgImage: "/images/Gallery/img-2.jpg"
        },
        {
            bgImage: "/images/Gallery/img-3.jpg"
        },
        {
            bgImage: "/images/Gallery/img-5.jpg"
        },
        {
            bgImage: "/images/Gallery/img-6.jpg"
        },
        {
            bgImage: "/images/Gallery/img-8.jpg"
        },
        {
            bgImage: "/images/Gallery/img-9.jpg"
        },
        {
            bgImage: "/images/Gallery/img-10.jpg"
        }
    ];
    const handleClick = (item, index)=>{
        setCurrentIndex(index);
        setClickedImage(item.bgImage);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "".concat((_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_4___default().restaurant_gal), " common_padding"),
            id: "popular_dishes",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    ...gallery_slider,
                    className: "gallery_slider",
                    children: galleryImages.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_pages_Restaurant_module_scss__WEBPACK_IMPORTED_MODULE_4___default().gallery_child),
                            onClick: ()=>handleClick(item, index),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: item.bgImage,
                                onClick: ()=>handleClick(item, index),
                                alt: "Food Image ".concat(index + 1)
                            })
                        }, index))
                }),
                clickedImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Gallerymodal_Gallerymodal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    galleryImages: galleryImages,
                    currentIndex: currentIndex,
                    setClickedImage: setClickedImage
                })
            ]
        })
    });
}


/***/ }),

/***/ 1027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"restaurant_banner":"Restaurant_restaurant_banner__R8ast","banner_text":"Restaurant_banner_text___9T0g","banner_text_con":"Restaurant_banner_text_con__qD_Ea","wedding_meeting_banner":"Restaurant_wedding_meeting_banner__ol2Kp","banner_btn":"Restaurant_banner_btn__eYnP2","bounce":"Restaurant_bounce__ZHKzx","restaurant":"Restaurant_restaurant__8q4_f","restaurant_top":"Restaurant_restaurant_top__nDa3F","res_top_left":"Restaurant_res_top_left__tXWa1","center_div":"Restaurant_center_div__Sk0Vx","res_top_right":"Restaurant_res_top_right__Xu2zR","restaurant_top_two":"Restaurant_restaurant_top_two__y4pf_","res_top_left_two":"Restaurant_res_top_left_two__NJzvY","res_top_right_two":"Restaurant_res_top_right_two__tDjXI","restaurant_gal":"Restaurant_restaurant_gal__6zZeh","gallery_main":"Restaurant_gallery_main__r__8l","gallery_child":"Restaurant_gallery_child__FKNBV","image_sec":"Restaurant_image_sec__0F8ZR","bar_image":"Restaurant_bar_image__Iphap","best_venue_sec":"Restaurant_best_venue_sec__D_IFJ","best_venue_sec_main":"Restaurant_best_venue_sec_main__65U0_","wedding_amenities":"Restaurant_wedding_amenities__zxz55","amenities_main":"Restaurant_amenities_main__KH5aM","amenities":"Restaurant_amenities___QyIS","gallery_sec":"Restaurant_gallery_sec__SQk4F","gallery_sec_heading":"Restaurant_gallery_sec_heading__i15fF"};

/***/ })

}]);